import {
  createFileRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';
import { Header } from '@/components/Header';
import { RoleDetail } from '@/pages/RoleDetail';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-roles/$roleId'
)({
  component: RoleDetailPage,
});

function RoleDetailPage() {
  const router = useRouterState();
  const { roleId } = Route.useParams();
  const isEditRoute = router.matches.some(
    (match) =>
      match.routeId === '/_authenticated/_admin/admin/manage-roles/$roleId/edit'
  );

  if (isEditRoute) {
    return <Outlet />;
  }

  return (
    <>
      <Header
        enableBack
        fallbackTo="/admin/manage-roles"
        additionalClasses="bg-slate-700"
      />
      <RoleDetail roleId={roleId} />
    </>
  );
}
